import { render, staticRenderFns } from "./excludeProductDialog.vue?vue&type=template&id=4dc1c53f&scoped=true"
import script from "./excludeProductDialog.vue?vue&type=script&lang=js"
export * from "./excludeProductDialog.vue?vue&type=script&lang=js"
import style0 from "./excludeProductDialog.vue?vue&type=style&index=0&id=4dc1c53f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1c53f",
  null
  
)

export default component.exports